import React, { Fragment, useState } from "react";
import { get } from "../../../constants/apiRoutes";
import { useEffect } from "react";

const ViewConfiguration = () => {
  const [configData, setConfigData] = useState(null);

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      const result = await get("AppSettings/all_settings");
      setConfigData(result);
    } catch (error) {
      console.error("Failed to fetch data:", error);
    }
  };
  return (
    <Fragment>
      {configData ? (
        <Fragment>
          <div className="p-4 m-6">
            <h2 className="text-2xl font-bold mb-4">Configuration Settings</h2>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              {/* Map the settings data */}
              <div className="p-4 bg-white shadow-md rounded-lg border border-gray-200">
                <h3 className="text-lg font-semibold mb-2">General Settings</h3>
                <div className="flex flex-col gap-2">
                  <div className="flex justify-between">
                    <span className="font-medium text-gray-700">Ticker:</span>
                    <span>{configData.ticker}</span>
                  </div>
                  <div className="flex justify-between">
                    <span className="font-medium text-gray-700">
                      Conversion Rate (USD):
                    </span>
                    <span>{configData.convRateUSD}</span>
                  </div>
                  <div className="flex justify-between">
                    <span className="font-medium text-gray-700">
                      Conversion Factor (OZ):
                    </span>
                    <span>{configData.convFactOZ}</span>
                  </div>
                  <div className="flex justify-between">
                    <span className="font-medium text-gray-700">
                      Significant Value Change:
                    </span>
                    <span>{configData.significantValueChange}</span>
                  </div>
                  <div className="flex justify-between">
                    <span className="font-medium text-gray-700">
                      Timer Interval (Minutes):
                    </span>
                    <span>{configData.timerIntervalMinutes}</span>
                  </div>
                  <div className="flex justify-between">
                    <span className="font-medium text-gray-700">
                      Broadcast Currency:
                    </span>
                    <span>{configData.broadcast_currency}</span>
                  </div>
                </div>
              </div>
              <div className="p-4 bg-white shadow-md rounded-lg border border-gray-200">
                <h3 className="text-lg font-semibold mb-2">Markup Rates</h3>

                <table className="w-full text-sm text-gray-700 border-collapse">
                  <thead>
                    <tr className="bg-gray-100 text-left">
                      <th className="py-2 px-3 font-semibold">Karat</th>
                      <th className="py-2 px-3 font-semibold text-right">LT</th>
                      <th className="py-2 px-3 font-semibold text-right">M</th>
                      <th className="py-2 px-3 font-semibold text-right">GE</th>
                    </tr>
                  </thead>
                  <tbody>
                    {[
                      {
                        k: "14K",
                        LT: configData.markupRate14Karat_LT,
                        M: configData.markupRate14Karat_M,
                        GE: configData.markupRate14Karat_GE,
                      },
                      {
                        k: "18K",
                        LT: configData.markupRate18Karat_LT,
                        M: configData.markupRate18Karat_M,
                        GE: configData.markupRate18Karat_GE,
                      },
                      {
                        k: "21K",
                        LT: configData.markupRate21Karat_LT,
                        M: configData.markupRate21Karat_M,
                        GE: configData.markupRate21Karat_GE,
                      },
                      {
                        k: "22K",
                        LT: configData.markupRate22Karat_LT,
                        M: configData.markupRate22Karat_M,
                        GE: configData.markupRate22Karat_GE,
                      },
                      {
                        k: "24K",
                        LT: configData.markupRate24Karat_LT,
                        M: configData.markupRate24Karat_M,
                        GE: configData.markupRate24Karat_GE,
                      },
                    ].map((row, i) => (
                      <tr key={i} className="border-b last:border-none">
                        <td className="py-2 px-3 font-medium">{row.k}</td>
                        <td className="py-2 px-3 text-right">{row.LT}</td>
                        <td className="py-2 px-3 text-right">{row.M}</td>
                        <td className="py-2 px-3 text-right">{row.GE}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>

                <div className="flex justify-between mt-4">
                  <span className="font-medium text-gray-700">
                    Markup Type:
                  </span>
                  <span>
                    {configData.markupType === 0 ? "Percentage" : "Flat Rate"}
                  </span>
                </div>
              </div>

              {/* <div className="p-4 bg-white shadow-md rounded-lg border border-gray-200">
                <h3 className="text-lg font-semibold mb-2">Markup Rates</h3>
                <div className="flex flex-col gap-2">
                  <div className="flex justify-between">
                    <span className="font-medium text-gray-700">14 Karat:</span>
                    <span>{configData.markupRate18Karat}</span>
                  </div>
                  <div className="flex justify-between">
                    <span className="font-medium text-gray-700">18 Karat:</span>
                    <span>{configData.markupRate18Karat}</span>
                  </div>
                  <div className="flex justify-between">
                    <span className="font-medium text-gray-700">21 Karat:</span>
                    <span>{configData.markupRate21Karat}</span>
                  </div>
                  <div className="flex justify-between">
                    <span className="font-medium text-gray-700">22 Karat:</span>
                    <span>{configData.markupRate22Karat}</span>
                  </div>
                  <div className="flex justify-between">
                    <span className="font-medium text-gray-700">24 Karat:</span>
                    <span>{configData.markupRate24Karat}</span>
                  </div>
                  <div className="flex justify-between">
                    <span className="font-medium text-gray-700">
                      Markup Type:
                    </span>
                    <span>
                      {configData.markupType === 0 ? "Percentage" : "Flat Rate"}
                    </span>
                  </div>
                </div>
              </div> */}
              <div className="p-4 bg-white shadow-md rounded-lg border border-gray-200 col-span-1 md:col-span-2">
                <h3 className="text-lg font-semibold mb-2">Stream Times</h3>
                <ul className="list-disc pl-5">
                  {configData.streamTimes.map((time, index) => (
                    <li key={index} className="text-gray-700">
                      {time}
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        </Fragment>
      ) : (
        <p className="text-center m-4 text-2xl text-gray-400">Loading....</p>
      )}
    </Fragment>
  );
};

export default ViewConfiguration;
